<template>
  <ul class="errors-list">
    <li
      v-for="(error, index) of errors"
      :key="index">
      {{ error }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: false
    }
  }
}
</script>

<style scoped>

  .errors-list, .errors-list li{
    list-style: none;
  }

  .errors-list li{
    color: #e04040;
    font-size: 12px; line-height: 1.2;
  }

</style>
